class FilterOption extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleSubmit.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleSubmit.bind(this));
  }

  handleSubmit(e) {
    const target = e.currentTarget;
    const targetCollection = target.closest('.collection-product-grid').dataset.collectionUrl;
    const targetFilterLabel = target.closest('.facets__disclosure').querySelector('.facets__summary-label');
    const component = this;
    const sections = this.getSections();
    this.uncheckAll();
    this.selectCurrent();
    const isMainProductGrid = (target.closest('#main-collection-filters') && true) || window.isB2B;
    if (window.isB2B) {
      const searchElement = document.querySelector('.collection-b2b-header collection-b2b-search');
      if (searchElement) {
        searchElement.currentSort = target.dataset.sortOption;
      }
    }
    sections.forEach((section) => {
      const url = `${targetCollection}?sort_by=${target.dataset.sortOption}&section_id=${section.section}`;
      if (isMainProductGrid) {
        this.submitSorting();
      } else {
        component.renderSectionFromFetch(url, target);
        targetFilterLabel.textContent = target.querySelector('.filter-option-text').textContent;
      }
    });
  }

  uncheckAll() {
    this.parentElement.querySelectorAll('filter-option').forEach((filterOption) => {
      filterOption.querySelector('.facet-checkbox').classList.remove('active');
    });
  }

  selectCurrent() {
    this.querySelector('.facet-checkbox').classList.add('active');
  }

  submitSorting() {
    const filtersField = this.closest('.facet-filters__field');
    const sortByElement = filtersField && filtersField.querySelector('#SortBy');
    const form = this.closest('facet-filters-form');

    if (sortByElement) {
      sortByElement.value = this.dataset.sortOption;
      const event = new CustomEvent('facet:filter:change', { bubbles: true });
      sortByElement.dispatchEvent(event);
      form && form.debouncedOnSubmit(event);
    }
  }

  getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  renderSectionFromFetch(url, target) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderProductGridContainer(html, target);
      });
  }

  renderProductGridContainer(html) {
    const bundleGridContainer = document.getElementById('BundleProductGridContainer');
    bundleGridContainer.innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('BundleProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    document
      .getElementById('BundleProductGridContainer')
      .querySelector('#product-grid')
      .setAttribute('id', 'bundles-product-grid');

    document
      .getElementById('BundleProductGridContainer')
      .querySelectorAll('.detailed-product-card-main-container.customizer-card')
      .forEach((detailedProductCard) => {
        detailedProductCard.parentElement.classList.add('hidden');
      });

    document
      .getElementById('BundleProductGridContainer')
      .querySelectorAll('.detailed-product-card-main-container:not(.customizer-card)')
      .forEach((detailedProductCard) => {
        detailedProductCard.parentElement.classList.add('bundle-grid-item');
      });
  }
}

if (!window.customElements.get('filter-option')) {
  window.customElements.define('filter-option', FilterOption);
}
